import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Expo, TimelineLite, TimelineMax } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";

import {ch3_p02} from "../../../layouts/ch3_p02/ch3_p02"

export class Chapter3Page2 extends AbstractStoryState {

	readonly bg = this.addChild(new SceneSprite());
	readonly list = this.addChild(new SceneSprite());
	readonly frameLeft = this.addChild(new SceneSprite());
	readonly frameRight = this.addChild(new SceneSprite());

    public init(pSize: PIXI.Point, pData: any) {
		// exported layouts from Animate CC
        ch3_p02.call(this);
        this.frameLeft.visible = false;
		this.frameRight.visible = false;

		// super.init calls onResize
		super.init(pSize, pData);
	}

	public update(pDeltaTime: number) {
		super.update(pDeltaTime);
	}

	public animateIn(pOnComplete: ()=>void) {
        new TimelineLite()
            .from([this.bg], 1, {pixi: {
                alpha: 0,
            }}, 0)
            // fade in frame after bg because of blend mode
            .from([this.frameLeft, this.frameRight], 2, {pixi: {
                alpha: 0,
            }}, 1)
            .from(this.list, 2, {pixi: {
                y: this.list.y + 500, // position in previous panel
            }, ease: Expo.easeOut}, 0)
            .call(()=>{
                super.animateIn(pOnComplete);
            })
        ;
    }

    protected onAnimateInComplete() {
        super.onAnimateInComplete();
        // interactivity
        this.list.interactive = true;
        this.list.buttonMode = true;
        this.list.accessible = true;
        const dismissList = ()=>{
            this.gotoNextState({transition: "up"});
        }
        this.list.addListener(HLF.Input.Events.MOUSE_DOWN, dismissList);
        this.list.addListener(HLF.Input.Events.TOUCH_MOVE, dismissList);
    }
}